var exports = {
  "HP": "boxHeaderStyles__NmmzfI",
  "wy": "Box_1__ppotyV",
  "pv": "Box_2__u9sVS1",
  "v7": "FormControl_Label__JsVwdE",
  "w9": "Box_3__TuqASi",
  "pQ": "Box_4__W0zii1",
  "$n": "Button__MGCWQw",
  "ws": "Box_5__Lkpzn5",
  "m4": "Octicon__-jEX30",
  "D6": "Box_6__NkoTdo",
  "ks": "TextInput__p3tRsZ",
  "EY": "Text__uADSAm",
  "Hh": "ActionMenu_Button__EpNp9D",
};

module.exports = exports;
